import Headroom from "headroom.js";

export default class NavBar {
	constructor() {
		this.mobNavOpen = false;
		this.init();
	}

	init() {
		const checkbox = document.querySelectorAll('.primary-navigation input[type="checkbox"]');
		const header = document.querySelector(".header");

		// Init headroom
		const headroom = new Headroom(header, {
			offset: {
				up: header.clientHeight / 2,
				down: header.clientHeight
			},
			tolerance : {
				up : 5,
				down : 0
			},
			onPin() {
				document.querySelector("html").classList.add("has-header-pinned");
				document.querySelector("html").classList.remove("has-header-unpinned");
			},
			onUnpin() {
				document.querySelector("html").classList.add("has-header-unpinned");
				document.querySelector("html").classList.remove("has-header-pinned");
			}
		});
		headroom.init();

		if (!checkbox.length) return;

		// Init event listeners
		window.addEventListener("change", e => {
			this.unCheck(e, checkbox)
		});

		window.addEventListener("click", e => {
			const el = e.target;

			if (el.closest("button") !== null && el.closest("button").classList.contains("site-navigation__toggle")) {
				this.toggleNavigation(e);
			}

			this.unCheck(e, checkbox)

		});

		window.addEventListener("keydown", e => {
			if (e.key === "Escape") {
				this.toggleNavigation(e);
				this.unCheck(e, checkbox)
			}
		});

		window.addEventListener("DOMContentLoaded", this.setupMobNav);

	}

	setupMobNav() {
		const searchForm = document.querySelector(".site-navigation__search");
		const navLinks = document.querySelector(".site-navigation__list");

		const targetElSm = document.querySelector(".header__nav_featured");
		const targetElLg = document.querySelector(".site-navigation");
		const mq = window.matchMedia("(max-width: 991px)");

		function setupSm() {
			targetElSm.append(searchForm)
			targetElSm.append(navLinks)
		}

		function setupLg() {
			targetElLg.append(searchForm)
			targetElLg.append(navLinks)
		}

		if (window.innerWidth < 992) {
			setupSm()
		} else {
			setupLg();
		}

		function setup(e) {
			if (e.matches) {
				setupSm()
			} else {
				setupLg()
			}
		}

		mq.addEventListener("change", setup);
	}

	toggleNavigation(e) {
		this.mobNavOpen = !this.mobNavOpen;

		if (this.mobNavOpen === true && e.type === "keydown" && e.key === "Escape") {
			this.mobNavOpen = false;
		}

		if (this.mobNavOpen) {
			document.querySelector("html").classList.add("has-menu-open");
		} else {
			document.querySelector("html").classList.remove("has-menu-open");
		}

	}

	unCheck(e, checkbox) {
		
		if (e.type === "keydown" && e.key === "Escape") {
			checkbox.forEach(checkbox => checkbox.checked = false);
		}

		if (e.type === "change" && e.target.type === "checkbox" && e.target.closest(".primary-navigation") !== null) {
			const siblingsWrapper = e.target.closest(".primary-navigation");
			const siblings = siblingsWrapper.querySelectorAll('input[type="checkbox"]');
			checkbox.forEach(checkbox => {
				if (checkbox.id !== e.target.id) {
					checkbox.checked = false;
				}
			})
		}

		if (e.type === "click" && e.target.closest(".primary-navigation__item") === null) {
			checkbox.forEach(checkbox => checkbox.checked = false);
		}

	}

}